import api from "./api";

export const postChangeProfile = async (body) => {
  return api
    .post({
      endpoint: "/owner/profile",
      port: process.env.REACT_APP_PORT_OWNER,
      body,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
